module.exports = __webpack_public_path__ + "static/media/night.4e30e1a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/night.svg
// module id = 262
// module chunks = 0